import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Users, Award, Globe, Shield } from "lucide-react";
const About = () => {
  return <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-primary to-primary/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white mt-36">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              About UNIAO LAR & VIDA
            </h1>
            <p className="text-xl lg:text-2xl max-w-3xl mx-auto text-white/90">
              Your trusted bridge between Nigeria and Brazil for legal residency and investment opportunities
            </p>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Who We Are
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                UNIAO LAR & VIDA is a specialized Brazil Relocation & Residency Consultancy dedicated to assisting Nigerian and African high-net-worth individuals and families in legally establishing a permanent base in Brazil through real estate investment.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                We do not sell passports and do not promise automatic residency. Instead, we provide comprehensive, professional support to ensure our clients comply with Brazilian law and successfully obtain legal residency through legitimate investment channels.
              </p>
              <p className="text-lg text-gray-600">
                Our approach is built on transparency, legal compliance, and meticulous attention to detail, ensuring that every step of your residency journey is handled with the utmost professionalism.
              </p>
            </div>
            <div className="relative">
              <img src="https://static-us-img.skywork.ai/prod/user/head_picture/2010815373932027904_ChatGPT Image 12 de jan. de 2026, 17_28_16.png?image_process=quality,q_90/resize,w_1280/format,webp" alt="Professional business meeting" className="rounded-lg shadow-lg h-[328.984375px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              The principles that guide every aspect of our service delivery
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="text-center shadow-corporate">
              <CardContent className="p-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="h-8 w-8 text-primary" />
                </div>
                <h3 className="font-semibold text-lg mb-3">Legal Integrity</h3>
                <p className="text-gray-600">
                  Strict adherence to Brazilian immigration law and regulations
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center shadow-corporate">
              <CardContent className="p-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="h-8 w-8 text-primary" />
                </div>
                <h3 className="font-semibold text-lg mb-3">Client Focus</h3>
                <p className="text-gray-600">
                  Personalized service tailored to each client's unique needs
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center shadow-corporate">
              <CardContent className="p-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="h-8 w-8 text-primary" />
                </div>
                <h3 className="font-semibold text-lg mb-3">Excellence</h3>
                <p className="text-gray-600">
                  Commitment to the highest standards of professional service
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center shadow-corporate">
              <CardContent className="p-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Globe className="h-8 w-8 text-primary" />
                </div>
                <h3 className="font-semibold text-lg mb-3">Cross-Cultural Expertise</h3>
                <p className="text-gray-600">
                  Deep understanding of both Nigerian and Brazilian cultures
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Multidisciplinary Team
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A carefully assembled team of experts with complementary skills and deep cross-border experience
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="shadow-corporate">
              <CardContent className="p-6 text-center">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="h-10 w-10 text-primary" />
                </div>
                <h3 className="font-semibold text-xl mb-2">Brazilian Architect</h3>
                <p className="text-primary font-medium mb-3">Property Evaluation Specialist</p>
                <p className="text-gray-600">
                  Responsible for comprehensive property evaluation and technical due diligence. Ensures all real estate investments meet Brazilian standards and regulations.
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-corporate">
              <CardContent className="p-6 text-center">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Globe className="h-10 w-10 text-primary" />
                </div>
                <h3 className="font-semibold text-xl mb-2">International Relations Specialist</h3>
                <p className="text-primary font-medium mb-3">10+ Years Brazil Experience</p>
                <p className="text-gray-600">
                  Extensive experience in Brazil-Nigeria relations, cultural navigation, and cross-border business operations. Facilitates smooth transitions for clients.
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-corporate">
              <CardContent className="p-6 text-center">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="h-10 w-10 text-primary" />
                </div>
                <h3 className="font-semibold text-xl mb-2">Nigerian Lawyer</h3>
                <p className="text-primary font-medium mb-3">Immigration Law Expert</p>
                <p className="text-gray-600">
                  Specializes in legal compliance and immigration support. Ensures all documentation and processes meet both Nigerian and Brazilian legal requirements.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-16 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Our Mission
          </h2>
          <p className="text-xl text-white/90 max-w-4xl mx-auto mb-8">
            To provide Nigerian and African high-net-worth individuals and families with a secure, legal, and professional pathway to establishing permanent residency in Brazil through real estate investment, while ensuring full compliance with all applicable laws and regulations.
          </p>
          <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90">
            <Link to="/contact">Start Your Journey With Us</Link>
          </Button>
        </div>
      </section>

      <Footer />
    </div>;
};
export default About;